
import { Link } from 'react-router-dom';

export default function ConceptSection() {
  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 tracking-wider text-sub" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            SALON ROOM
          </h2>
          <p className="text-sm sm:text-base text-sub/70 tracking-widest" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            岡山市で信頼される美容室
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-16">
          <div className="order-2 lg:order-1">
            <h3 className="text-2xl sm:text-3xl font-bold mb-6 tracking-wider text-sub" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              お客様一人ひとりに<br />寄り添ったスタイル提案
            </h3>
            <p className="text-sm sm:text-base text-sub/80 leading-relaxed mb-6">
              おかやま美容室は、岡山市北区を拠点に2000年の設立以来、地域の皆様に愛され続けている美容室です。経験豊富なスタイリストが、お客様のライフスタイルや髪質、顔立ちに合わせた最適なヘアスタイルをご提案いたします。
            </p>
            <p className="text-sm sm:text-base text-sub/80 leading-relaxed mb-8">
              丁寧なカウンセリングを大切にし、お客様の「なりたい」を実現するために、最新のトレンドと確かな技術を融合させたスタイリングをお届けします。岡山市でヘアサロンをお探しの方、髪のお悩みをお持ちの方は、ぜひ一度ご来店ください。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center px-6 py-3 bg-primary text-white text-sm font-semibold rounded-full hover:bg-primary/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              詳しく見る
              <i className="ri-arrow-right-line ml-2 w-5 h-5 flex items-center justify-center"></i>
            </Link>
          </div>
          <div className="order-1 lg:order-2">
            <div className="relative h-96 sm:h-[500px] rounded-lg overflow-hidden shadow-xl">
              <img
                src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/75786d9f60b8647ecee7491a84de3209.png"
                alt="おかやま美容室の店内 - 岡山市の美容室"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          <div className="bg-accent/50 p-6 sm:p-8 rounded-lg">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white rounded-full flex items-center justify-center mb-4 sm:mb-6 shadow-md">
              <i className="ri-scissors-cut-line text-2xl sm:text-3xl text-primary w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h4 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 tracking-wider text-sub" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              確かな技術力
            </h4>
            <p className="text-sm text-sub/80 leading-relaxed">
              経験豊富なスタイリストが、最新のカット技術とトレンドを取り入れた施術で、お客様の魅力を最大限に引き出します。
            </p>
          </div>

          <div className="bg-accent/50 p-6 sm:p-8 rounded-lg">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white rounded-full flex items-center justify-center mb-4 sm:mb-6 shadow-md">
              <i className="ri-heart-line text-2xl sm:text-3xl text-primary w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h4 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 tracking-wider text-sub" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              丁寧なカウンセリング
            </h4>
            <p className="text-sm text-sub/80 leading-relaxed">
              お客様のご要望やライフスタイルをしっかりとヒアリングし、一人ひとりに最適なスタイルをご提案いたします。
            </p>
          </div>

          <div className="bg-accent/50 p-6 sm:p-8 rounded-lg sm:col-span-2 lg:col-span-1">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white rounded-full flex items-center justify-center mb-4 sm:mb-6 shadow-md">
              <i className="ri-leaf-line text-2xl sm:text-3xl text-primary w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h4 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 tracking-wider text-sub" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              髪と頭皮に優しい施術
            </h4>
            <p className="text-sm text-sub/80 leading-relaxed">
              厳選した高品質なヘアケア製品を使用し、髪と頭皮の健康を第一に考えた施術を行います。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
